import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import SoftBox from "components/SoftBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import TimelineList from "examples/Timeline/TimelineList";
import TimelineItem from "examples/Timeline/TimelineItem";
import axios from "axios";
import { Navigate } from "react-router-dom";
import FaqCollapse from "layouts/pages/pricing-page/components/FaqCollapse";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import Modal from "react-modal";
import IconClose from "examples/Icons/CloseButton";
import Upload from "antd/es/upload/Upload";
import SoftInput from "components/SoftInput";
import SoftEditor from "components/SoftEditor";
import Swal from "sweetalert2";
import { Popconfirm, Image } from "antd";

const api_url = process.env.REACT_APP_API_URL;


const centuryes = ["I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X", "XI", "XII", "XIII", "XIV", "XV", "XVI", "XVII", "XVIII", "XIX", "XX", "XXI"];

const modules = {
  toolbar: [
    ["bold", "italic", "underline", "strike", { "script": "super" }], // toggled buttons
    ["clean"], // remove formatting button
  ],
};



function stripHtml(html) {
  if (!html || typeof html !== 'string') return '';
  return html.replace(/<[^>]*>/g, '');
}


const Timeline = () => {
  const [data, setData] = useState([]); // Stocăm datele extrase pentru fiecare perioadă
  const [periods, setPeriods] = useState([]); // Stocăm lista de perioade
  const [faqTable, setFaqTable] = useState({});
  const [modalLoading, setModalLoading] = useState(false);
  const [loading, setLoading] = useState(false);

  const [tempPeriodsElement, setTempPeriodsElement] = useState([]);
  const [modalTitle, setModalTitle] = useState("");
  const [modalText, setModalText] = useState(""); //for images
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalPeriod, setModalPeriod] = useState("");
  const [modalId, setModalId] = useState("");
  const [modalmodTitle, setModalModTitle] = useState("");
  const [modalImages, setModalImages] = useState([]);
  const [modalName, setModalName] = useState("");
  const [edit, setEdit] = useState(true);
  const [titles, setTitles] = useState([]); 

  const switchFaqTable = (name) => {
    setFaqTable(prevState => ({
      ...prevState,
      [name]: !prevState[name]
    }));
  };




const [century, setcentury] = useState("I");
useEffect(() => {
  setLoading(true);
  var tempCentury = century ? century : "I";
  axios.get(api_url + `/dclr/all_by_cent/${tempCentury}`).then(
    (response) => {
      var message = response.data.message;
      var obj = JSON.parse(message);
      setData(obj);
      console.log(obj);
      setLoading(false);
    },
    [century]
  );
}, [century]);

useEffect(() => {
  setLoading(true);
  var dataTemp = data;
  var periodObj = {};
  var titleObj = {};
  dataTemp.map((item) => {
    periodObj[item["_source"].period] = 1;
    titleObj[stripHtml(item["_source"].title.replace(/<\/?[^>]+(>|$)/g, ""))] = 1;
  });

  var periodsTemp = Object.keys(periodObj);
  var titlesTemp = Object.keys(titleObj);
  //console.log(periodObj);
  setPeriods(periodsTemp);
  setTitles(titlesTemp);
  setLoading(false);
}, [data]);



useEffect(() => {
  setLoading(true);
  var faqTableTemp = {};
  titles.map((title) => {
    faqTableTemp[title] = 0;
  });
  setFaqTable(faqTableTemp);
  setLoading(false);
}, [titles]);



  const handleDelete = (delData, type) => () => {

    var url;
    if (type === "id") url = api_url + "/dclr/delete-id?id=" + delData;
    else if (type === "period") url = api_url + "/dclr/delete?century=" + delData;
    console.log(delData);
    var jwToken = localStorage.getItem("token");
    const headers = {
      Authorization: "Bearer " + jwToken,
    };
    axios
      .delete(url, { headers: headers })
      .then((response) => {
        console.log(response.data);
        //throw swal success
        Swal.fire({
          icon: "success",
          title: "Succes!",
          text: "Articolul a fost șters cu succes!",
        }).then(() => {
          var tempCentury = century ? century : "I";
          setcentury("");
          setTimeout(() => {
            setcentury(tempCentury);
          }, 2500); // Reincarca datele
        });
      })
      .catch((error) => {
        console.error(error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Ceva nu a mers bine!",
        });
      });
  };



  const handleEdit =
    (
      modTitle,
      id,
      period,
      text,
      title,
    ) =>
    () => {
      const entryToEdit = data.find(entry => entry["_source"].id === id);
      if (!entryToEdit) {
        console.error("Intrarea nu a fost găsită.");
        setEdit(false);
      } else {
        setEdit(true);
      }

      const htmlContent = text.map(item => item.paragraph).join("")

      text = htmlContent;
      setModalModTitle(modTitle);
      setModalTitle(title);
      setModalText(text);
      setModalPeriod(period);
      setModalId(id);
      setModalIsOpen(true);
    };

  
    const handleSave = () => {
      setModalLoading(true);
      const paragraphs = modalText.split("|||").map(p => ({
        paragraph: [p.trim()]
      }));

      const formattedTitle = `<p class="text-mare">${modalTitle.replace(/<p>/g, '<span class="CharOverride-1">').replace(/<\/p>/g, '</span>')}</p>`;
    
      const requestBody = {
        id: modalId,
        newTitle: formattedTitle,
        period: stripHtml(modalPeriod),
        newText: paragraphs,
        images: []
      };
    
      var jwToken = localStorage.getItem("token");
      const headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + jwToken,
      };
      var url;
      edit ? (url = api_url + "/dclr/update-id") : (url = api_url + "/dclr/add");
    
      axios
      .post(url, requestBody, { headers: headers })
      .then((response) => {
        console.log(response.data);
        setModalIsOpen(false);
        Swal.fire({
          icon: "success",
          title: "Succes!",
          text: "Articolul a fost adaugat cu succes!",
        }).then(() => {
          var tempCentury = century ? century : "I";
          setcentury("");
          setTimeout(() => {
            setcentury(tempCentury);
          }, 2500);
        });
        setModalLoading(false);
      })
      .catch((error) => {
        console.error(error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Ceva nu a mers bine!",
        });
        setModalLoading(false);
      });
    };    

const elements = 
    faqTable &&
    titles &&
    titles.map((title, index) => {   
      return (
        <FaqCollapse 
          title={title}
          key={title}
          open={faqTable[title]}
          onClick={() => switchFaqTable(title)}
        >  
          <div style={{ display: "flex", flexDirection: "row", gap: "60px", marginBottom: "15px" }}>
              <SoftTypography
                  className="cursor-pointer"
                  variant="h6"
                  fontWeight="bold"
                  color="text"
                  onClick={handleEdit("Adaugare intrare subsecol", -1, periods[index], [], [], [])}
                >
                +  Adauga subsectiune
              </SoftTypography>
            </div>
  
          {data.map((item) => {
            if (title != stripHtml(item["_source"].title.replace(/<\/?[^>]+(>|$)/g, ""))) return <></>;
            var text = "";
          const paragraphs = item["_source"].text.map((textItem, textIndex) => (
            <div key={textIndex} dangerouslySetInnerHTML={{ __html: textItem.paragraph }} />
          ));
            text = paragraphs;
            return (
              <div>
              <TimelineItem
                icon="inventory_2"
                //key from index i
                key={index}
                dateTime=""
                color="info"
                title={
                <div style={{display: 'flex', justifyContent: "space-between"}}>
                  <div>{title}</div>
                    <div style={{display: 'flex', flexDirection: "row", gap: "60px"}}>
                        <SoftBox
                          style={{ display: "inline-block" }}
                          key={item["_source"].id + 10000}
                          p={0.5}
                          mb={1.5}
                          onClick={handleEdit(
                            "Editare intrare",
                            item["_source"].id,
                            item["_source"].period,
                            item["_source"].text,
                            item["_source"].title,
                          )}
                        >
                          <SoftTypography
                            className="cursor-pointer"
                            variant="h6"
                            fontWeight="bold"
                            color="text"
                            key={item["_source"].id}
                          >
                            ✎ Editare
                          </SoftTypography>
                        </SoftBox>

                        <SoftBox
                          style={{ display: "inline-block" }}
                          key={item["_source"].id + 20000}
                          p={0.5}
                          mb={1.5}
                        >
                        <Popconfirm
                            title="Sigur doriți să ștergeți articolul?"
                            onConfirm={handleDelete(item["_id"], "id")}
                            okText="Da"
                            cancelText="Nu"
                          >
                          <SoftTypography
                            className="cursor-pointer"
                            variant="h6"
                            fontWeight="bold"
                            color="text"
                            key={item["_source"].id}
                          >
                            🗑 Ștergere subsecol
                          </SoftTypography>
                          </Popconfirm>
                        </SoftBox>
                    </div>
                </div>

                } 
                description={text}
              />
              </div>
            );
          })}
        </FaqCollapse>
      );
    });

  return (
    <>
    <Modal
  shouldCloseOnOverlayClick={false}
  isOpen={modalIsOpen}
  onRequestClose={() => setModalIsOpen(false)}
  contentLabel="Editare intrare"
  style={{
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      zIndex: 10000, // Set the z-index here
    },
    content: {
      color: "lightsteelblue",
    },
  }}
>
  <SoftBox p={3}>
    <div className="close-button">
      <SoftButton
        variant="contained"
        color="secondary"
        onClick={() => {
          setModalTitle("");
          setModalText("");
          setModalPeriod("");
          setModalId("");
          setModalModTitle("");
          setModalIsOpen(false);
        }}
      >
        <IconClose />
      </SoftButton>
    </div>
    <SoftTypography variant="h3" component="h3">
            <div style={{ textAlign: "center"}}>{modalmodTitle}</div>
          </SoftTypography>
    <SoftBox my={5}>
    
      <SoftBox my={5}>
        <SoftTypography variant="h4" component="h4">
            <div>Perioada</div>
          </SoftTypography>
          <SoftEditor
            modules={modules}
            preserveWhitespace={true}
            value={modalPeriod ? modalPeriod : ""}
            onChange={(value) => {
               setModalPeriod(value);
            }}
              />
      </SoftBox>
        <SoftBox my={5}>
          <SoftTypography variant="h4" component="h4">
              <div>Titlu</div>
          </SoftTypography>
          <SoftEditor
            modules={modules}
            preserveWhitespace={true}
            value={modalTitle ? modalTitle : ""}
            onChange={(value) => {
               setModalTitle(value);
            }}
              />
        </SoftBox>

        <SoftBox my={5}>
              <SoftTypography variant="h4" component="h4">
                <div>Text</div>
              </SoftTypography>
              <SoftEditor
                modules={modules}
                preserveWhitespace={true}
                value={modalText ? modalText : ""}
                onChange={(value) => {
                  setModalText(value);
                }}
              />
            </SoftBox>
    </SoftBox>
<Grid container spacing={3} mb={3} justifyContent={"center"}>
            <Grid item>
              {modalLoading ? (
                <SoftButton variant="contained" color="info">
                  Se încarcă...
                </SoftButton>
              ) : (
                <SoftButton
                  variant="contained"
                  color="info"
                  onClick={handleSave}
                >
                  Salvează
                </SoftButton>
              )}
            </Grid>
      <Grid item>
        <SoftButton
          variant="contained"
          color="secondary"
          onClick={() => {
            setModalTitle("");
            setModalText("");
            setModalPeriod("");
            setModalId("");
            setModalModTitle("");
            setModalIsOpen(false);
          }}
        >
          Anulează
        </SoftButton>
      </Grid>
    </Grid>
  </SoftBox>
</Modal>
{localStorage.getItem("token") == null ? (
        <Navigate to="/authentication/login" />
      ) : (
        <DashboardLayout>
          <DashboardNavbar />
          {/** menu with letters from a-z, horizontall */}

          {loading ? (
            <SoftBox my={3}>
              <SoftTypography variant="h6" component="h6">
                <div style={{ textAlign: "center" }}>Se încarcă...</div>
              </SoftTypography>
            </SoftBox>
          ) : (
            <SoftBox my={3}>
              <Grid container spacing={3} mb={3} justifyContent={"center"}>
                <Grid item>
                  {centuryes.map((centuryI) => {
                    return (
                      <a
                        key={centuryI}
                        href={"#" + centuryI}
                        onClick={() => setcentury(centuryI)}
                        style={{
                          padding: "10px",
                          color: century == centuryI ? "#17C1E8" : "inherit",
                          fontWeight: century == centuryI ? "bold" : "normal",
                        }}
                      >
                        {centuryI}
                      </a>
                    );
                  })}
                </Grid>
              </Grid>
              <SoftBox mb={3}>
              <div style={{ display: "flex", flexDirection: "row", gap: "60px", marginBottom: "15px" }}>
                <SoftButton
                  variant="contained"
                  color="info"
                  onClick={handleEdit("Adaugare intrare",-1, [], [], [], [])}
                >
                  + Adaugă intrare
                </SoftButton>
              <Popconfirm
                    title="Sigur doriți să ștergeți secolul?"
                   onConfirm={handleDelete(century, "period")}
                    okText="Da"
                    cancelText="Nu"
                  >
                  <SoftButton
                     variant="contained"
                     color="info"
                    // Nu ai nevoie să folosești SoftTypography aici, SoftButton ar trebui să fie suficient
                  >
                    🗑 Ștergere secol
                  </SoftButton>
                  </Popconfirm>
                </div>
                </SoftBox>
              <TimelineList title="Dicționar Cronologic Al Limbii Române">
                {elements}
              </TimelineList>
            </SoftBox>
          )}
          <Footer />
        </DashboardLayout>
      )}
    </>
  );
}




export default Timeline;

